import React from "react";

function AdvancedSelctionModal({propData,section_type,object_type,Push,Pop,setSearch, setSearchToState, handleNext, handlePrev, prevValid, nextValid}) {
    var prop_data = propData

    return (
        <div>

            <div className="modal fade" id="AdvancedSelctionModal">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row justify-content-between">
                                <input className="form-control col-10" value={setSearch} placeholder="Search" onChange={e=> setSearchToState(e.target.value)}/>
                                <button className="btn btn-sm btn-primary" onClick={(e)=> {e.preventDefault(); setSearchToState('')}}>
                                </button>
                            </div>
                            <div className="table-responsive xrounded card-table">
                                <table className="table items-table table-responsive-sm">
                                    <tbody>
                                        <tr>
                                            <th className="my-0 text-black font-w500 fs-3">Name</th>
                                            <th className="my-0 text-black font-w500 fs-3">Select</th>
                                        </tr>
                                        {prop_data.length > 0 &&
                                            prop_data.map((item, index) => {
                                                var id =  item.id
                                                if(section_type==="OFFER"){
                                                    var name = item.heading
                                                }
                                                else{
                                                    var name = item.name
                                                }
                                                return (
                                                    <tr className="alert alert-dismissible border-0">
                                                        <td>
                                                            <div className="media">
                                                                <div className="media-body">

                                                                    <small className="font-w500">
                                                                        <a className="text-primary" href="javascript:void(0);">
                                                                            {id} : {name}
                                                                            {/* {JSON.stringify(item)} */}
                                                                            {section_type==="OFFER"&&<>
                                                                            {object_type==="ITEM"&&<><br/>{item.item.name}</>}
                                                                            {object_type==="BRANCH"&&<><br/>{item.branch.name}</>}
                                                                            </>}
                                                                        </a>
                                                                    </small>

                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h4 className="my-0 text-black font-w600">
                                                                <div><span onClick={(e) => {
                                                                            e.preventDefault();
                                                                            Push(id, name);    
                                                                     }
                                                                    }
                                                                    style={{ fontSize: 25, cursor: 'pointer' }}>+</span>
                                                                </div>
                                                            </h4>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>


                        <div className="modal-footer">
                            {/* <button type="button" className="btn btn-danger light" data-dismiss="modal"
                                onClick={
                                    (e) => {
                                        e.preventDefault()

                                    }
                                }
                            >Close</button> */}
                            <button type="button" className="btn btn-primary" data-dismiss="modal"
                                onClick={
                                    (e) => {
                                        e.preventDefault()
                                        // void 0
                                        // void 0
                                        // Pop(index);
                                        // props.customerFunction(tagList)
                                        // props.nameFunction(catName)
                                    }
                                }
                            >OK</button>

                        </div>
                    </div>
                </div>
            </div>


        </div>

    )
}

export default AdvancedSelctionModal
